import {throttle} from 'throttle-debounce';

const MOBILE_BREAKPOINT = 768;

/**
 * Applies video src depending on what device we're using
 */
const setVideoSrc = (): void => {
  const els = document.querySelectorAll('[data-content-video]');
  if (els.length <= 0) return;

  els.forEach((video: HTMLVideoElement) => {
    const sourceMp4: HTMLSourceElement = video.querySelector('source[type="video/mp4"]');
    const sourceWebm: HTMLSourceElement = video.querySelector('source[type="video/webm"]');

    const videoMp4 = video.dataset.videoMp4;
    const videoWebm = video.dataset.videoWebm;
    const videoMp4Mob = video.dataset.videoMp4Mob;
    const videoWebmMob = video.dataset.videoWebmMob;

    let changed = false;

    if (window.innerWidth > MOBILE_BREAKPOINT && video.dataset.mode !== 'dt') {
      video.dataset.mode = 'dt';
      changed = true;
    } else if (window.innerWidth <= MOBILE_BREAKPOINT && video.dataset.mode !== 'mob') {
      video.dataset.mode = 'mob';
      changed = true;
    }

    if (changed) {
      if (videoMp4 || videoMp4Mob) {
        sourceMp4.setAttribute('type', 'video/mp4');
        sourceMp4.setAttribute('src', window.innerWidth > MOBILE_BREAKPOINT ? videoMp4 : videoMp4Mob);
      }

      if (videoWebm || videoWebmMob) {
        sourceWebm.setAttribute('type', 'video/webm');
        sourceWebm.setAttribute('src', window.innerWidth > MOBILE_BREAKPOINT ? videoWebm : videoWebmMob);
      }

      video.load();
      //video.play() is async so need to handle the error when resizing happens and the load interrupts the playing
      video.play().then(() => {
        return
      }).catch(e => {
        if (e.code === DOMException.ABORT_ERR) {
          return
        }
      })
    }
  });
}

/**
 * 
 */
const initResponsiveVideo = (): void => {
  setVideoSrc();
  window.addEventListener('resize', throttle(250, false, () => setVideoSrc()));
}

export default initResponsiveVideo;